// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // Import Firebase Storage

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCx5vr4-V0jgIMD0AaRpxaXwT_HK65NxJo",
  authDomain: "offplanner-2cb64.firebaseapp.com",
  projectId: "offplanner-2cb64",
  storageBucket: "offplanner-2cb64.firebasestorage.app",
  messagingSenderId: "694705771635",
  appId: "1:694705771635:web:da75bea2fe03f227b4c606",
  measurementId: "G-2W1TBQEYZ8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Auth, and Storage
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // Initialize and export Firebase Storage

export default app;
